import { apiClient } from '@slot-nx/core'
import { gameConfig } from '../../../config'
import { BetDetailResponse } from './betDetailResponse'

export interface IBetDetailApi {
  getBetDetail(refNo: number, statementDate: string): Promise<BetDetailResponse>
}

export const betDetailApi: IBetDetailApi = {
  async getBetDetail(refNo: number, statementDate: string): Promise<BetDetailResponse> {
    const res = await apiClient.get<BetDetailResponse>(`${gameConfig.name}/player/betdetail`, {
      params: {
        refNo: refNo,
        statementDate: statementDate,
      },
    })

    return res.data
  },
}

// const mockBetDetail = {
//   refNo: 200000794079,
//   stake: 1.2,
//   payout: 19.2,
//   playerId: 'Fun132187USD_AS',
//   gameDetail: {
//     normalResult: {
//       resultSymbols: [
//         4,
//         5,
//         4,
//         11,
//       ],
//       payout: 4,
//     },
//     freeSpinResult: [
//       {
//         resultSymbols: [
//           2,
//           5,
//           5,
//           11,
//         ],
//         payout: 1.6,
//       },
//       {
//         resultSymbols: [
//           1,
//           4,
//           4,
//           11,
//         ],
//         payout: 1.6,
//       },
//       {
//         resultSymbols: [
//           5,
//           4,
//           5,
//           11,
//         ],
//         payout: 4,
//       },
//       {
//         resultSymbols: [
//           5,
//           4,
//           5,
//           11,
//         ],
//         payout: 4,
//       },
//       {
//         resultSymbols: [
//           4,
//           4,
//           5,
//           11,
//         ],
//         payout: 4,
//       },
//     ],
//   },
//   returnCode: 0,
//   message: '',
// }
